import types from './types';

const INITIAL_STATE = {
  isFetchingHelpCenterLinks: false,
};

const bannerReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {

  	case types.GET_HELP_CENTER_LINKS_REQUEST:
    	return {
      	...state,
        isFetchingHelpCenterLinks: true,
    };

		case types.GET_HELP_CENTER_LINKS_SUCCESS:
      return {
        ...state,
        result: action.payload,
        isFetchingHelpCenterLinks: false,
      };

		case types.GET_HELP_CENTER_LINKS_FAILURE:
    	return {
      	...state,
        result: [],
      	isFetchingHelpCenterLinks: false,
    };

    default:
    return state;
    }
  };

  export default bannerReducer;